import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { OutboundCampaignResponse } from '../models/responses/outbound-campaign-response';

@Injectable({
  providedIn: 'root'
})
export class OutboundCampaignService {

  constructor(private httpClient:HttpClient) { }

  runBatch(aiAgentNumber:number,formData:FormData){
    return this.httpClient.post<OutboundCampaignResponse>(`${environment.outboundCampaignUrl}/runBatch/${aiAgentNumber}`,formData);
  }
  schedule(aiAgentNumber:number,targetDate:Date,formData:FormData){
    return this.httpClient.post<OutboundCampaignResponse>(`${environment.outboundCampaignUrl}/scheduleBatch/${aiAgentNumber}/${targetDate}`,formData);
  }
  pause(id:number){
    return this.httpClient.post<OutboundCampaignResponse>(`${environment.outboundCampaignUrl}/pause/${id}`, null);
  }
  resume(id:number, payload: { callsPerBatch?: number } = {}){
    return this.httpClient.post<OutboundCampaignResponse>(`${environment.outboundCampaignUrl}/resume/${id}`, payload);
  }
  delete(id:number){
    return this.httpClient.delete<OutboundCampaignResponse>(`${environment.outboundCampaignUrl}/${id}`);
  }
}
